import React from "react";
import { lightThemeColors } from "../../assets/styles/colors";
import styled from "styled-components";

import { copyToClipboard } from "../../helper/copy";
import { useInstanceContext } from "../../context/useInstanceContext";

const ReactNativeIntegrationText = ({ ref, onMouseMove }) => {
  const { selectedInstance } = useInstanceContext();

  const indent = "        ";
  return (
    <Container>
      <InfoText>Use the SDK from your React Native App.</InfoText>
      <Line>
        <TextCodeContainer id={""} ref={ref} onMouseMove={onMouseMove}>
          {`// Once configured, you can utilize the various functionalities provided by Grovs.`}
          <span
            data-tooltip-id={"androidSDK-tooltip"}
            data-tooltip-content={"Click text to copy"}
            onClick={(e) => copyToClipboard(e.currentTarget.innerText)}
          >{`import { Grovs } from 'react-native-grovs-wrapper';`}</span>
          <br />
          <br />
          {`// You can receive deep link events by registering a listener. Here's how you can implement it:`}
          <span
            data-tooltip-id={"androidSDK-tooltip"}
            data-tooltip-content={"Click text to copy"}
            onClick={(e) => copyToClipboard(e.currentTarget.innerText)}
          >{`const listener = Grovs.onDeeplinkReceived((data) => {
    console.log(data);
});
`}</span>
          <br />

          {`// When you don't want to receive events anymore`}
          <span
            data-tooltip-id={"androidSDK-tooltip"}
            data-tooltip-content={"Click text to copy"}
            onClick={(e) => copyToClipboard(e.currentTarget.innerText)}
          >{`listener.remove(); // Stop receiving events`}</span>
        </TextCodeContainer>
      </Line>
    </Container>
  );
};

export default ReactNativeIntegrationText;

const TextCodeContainer = styled.pre`
  display: flex;
  flex-direction: column;
  border: 1px solid ${lightThemeColors.menuBorder};
  border-radius: 5px;
  padding: 16px;
  width: 100%;
  overflow: hidden;
  white-space: pre-wrap;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${lightThemeColors.darkColorFaded60};
  h2 {
    white-space: pre-wrap;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: ${lightThemeColors.darkColorFaded60};
  }
  span {
    &:hover {
      background: ${lightThemeColors.sidebar.linkBg};
    }
    white-space: pre-wrap;
    width: fit-content;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    font-weight: 600;
    color: ${lightThemeColors.primaryColor};
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${lightThemeColors.background};
  width: 100%;
  gap: 20px;
`;

const SubcategoryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 40px;
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  p {
    color: ${lightThemeColors.darkColor};
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
  }
`;
const Separator = styled.div`
  display: flex;
  height: 1px;
  min-height: 1px;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  opacity: 0.1;
  margin: 30px 0;
`;

const InfoText = styled.p`
  color: ${lightThemeColors.darkColor};
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  max-width: 635px;
  h3 {
    margin-top: 10px;
    color: ${lightThemeColors.darkColorFaded};
    font-size: 15px;
  }
`;
